import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m3.8 20.2 10.4-10.4" }),
		/* @__PURE__ */ _jsx("path", { d: "m12.8 8.4 2.8 2.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 3v4.4M15.8 5.2h4.4" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.6 15.2v3.2M17 16.8h3.2" })
	]
});
const ForwardRef = forwardRef(SvgWand);
export default ForwardRef;
